import * as React from "react";
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react";
import { Link, CMSState, ImageSize } from "../../../../cms/blocks/types.gen";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { toRelativeUrl } from "../../../../../helpers";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type QuoteBlockProps<extra_images> = {
  index: number
  text: string
  author?: string
  company?: string
  primary_button?: Link | null
  secondary_button?: Link | null
  image?: WordPress.MediaResponse
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type QuoteBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  quote_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function QuoteBlock<customBlockData, extra_images>(
  props: QuoteBlockProps<extra_images>,
  options?: { style?: QuoteBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
        return (
          <section className={`block block--quote${props.image ? ' block--with-image' : ' block--no-image'}`}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            <div className="block__inner container--xl grid--block">
              <div className="block__content">
                <blockquote className="block__quote">
                  <p dangerouslySetInnerHTML={{__html: props.text}} />
                </blockquote>

                {(props.author || props.company) && <figcaption className="block__caption typo--2xs"><span>{props.author}</span> {props.author && props.company && "|"} <span>{props.company}</span></figcaption>}
                
                {(props.primary_button || props.secondary_button) &&              
                  <footer className="block__footer">
                    {props.primary_button && (
                      link(linkWrapper({title:props.primary_button.title,url:props.primary_button.url}),
                        { classname: 'button button--primary' },
                        props.primary_button.title
                        ) 
                    )}
                    {props.secondary_button && (
                      link(linkWrapper({title:props.secondary_button.title,url:props.secondary_button.url}),
                        { classname: 'button button--secondary' },
                        props.secondary_button.title
                        )
                    )}
                  </footer>
                }
              </div>

              {props.image && props.image.media_details.sizes.quote &&
                <div className="block__visual">
                  <img
                    src={getImageAttribute(props.image, 'quote', 'source_url')}
                    width={getImageAttribute(props.image, 'quote', 'width')}
                    height={getImageAttribute(props.image, 'quote', 'height')}
                    alt={props.image.alt_text ? props.image.alt_text : ''}
                  />
                </div>}
            </div>
          </section>
        )
      },
    })
}
